import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

export const INVESTMENT_BUSINESS_OBJECT_ENUM = 1;
export const FIRM_BUSINESS_OBJECT_ENUM = 2;
export const COMPANY_BUSINESS_OBJECT_ENUM = 3;
export const DEAL_BUSINESS_OBJECT_ENUM = 4;

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.BusinessObjectEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    businessObjectEnumList: { items: data, total },
  } = await sdk.getListBusinessObjectEnum(
    filterSortPage({
      filter,
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { businessObjectEnum: data } = await sdk.getOneBusinessObjectEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { businessObjectEnumMany: data } = await sdk.getManyBusinessObjectEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const businessObjectEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
